import React, { useEffect } from 'react';

import { TourVariationViewModel } from '@api/index';
import RadioGroup, { ResetSelectionFNRef } from '@components/RadioGroup';

import PackageVariation from '../PackageVariation';
import { VariationPriceListProps } from './types';
import { Container, ErrorTitle, Title } from './styled';
import { getLabel, getValue, getVariationIdAndIndex } from './helpers';

export type { ResetSelectionFNRef };

const VariationPriceList = ({
  variations,
  onVariationSelected,
  resetRef,
  selectedIndex,
  title,
  disabled,
  tourCard,
}: VariationPriceListProps) => {
  // =====================================
  // Select first variation when page mount
  // =====================================
  useEffect(() => {
    if (variations.length === 1) {
      onVariationSelected(variations[0]);
    }
  }, []);

  return variations.length ? (
    <>
      {disabled ? (
        <ErrorTitle>
          Devam edebilmek için geçerli çocuk tarihi giriniz.
        </ErrorTitle>
      ) : (
        <Title>{title}</Title>
      )}

      <Container stretchChild>
        <RadioGroup
          options={variations}
          getLabel={getLabel}
          getValue={getValue}
          direction='column'
          onChange={(value) => {
            // if the radio give us the variation id then we will find the selected variation first, if not, we will call onVariationSelected
            if (typeof value === 'string') {
              const [variationId] = getVariationIdAndIndex(value);
              const selectedVariation = variations?.find(
                (item) => item.variationId === variationId
              );

              if (selectedVariation) {
                onVariationSelected?.(selectedVariation);
              }
            } else {
              onVariationSelected?.(value);
            }
          }}
          selectedIndex={selectedIndex ?? -1}
          disabled={disabled}
          getOption={(value) => {
            const [variationId, index] = getVariationIdAndIndex(value);
            const option = variations.find(
              (v) => v.variationId === variationId
            ) as TourVariationViewModel;
            return [option, +index] as [TourVariationViewModel, number];
          }}
          renderRadioElement={(
            radio,
            variation: TourVariationViewModel,
            index,
            onSelect
          ) => {
            return (
              <PackageVariation
                tourCard={tourCard}
                key={index as number}
                onClick={disabled ? undefined : onSelect}
                disabled={disabled}
                {...variation}
              >
                {radio}
              </PackageVariation>
            );
          }}
          resetSelectionFnRef={resetRef}
        />
      </Container>
    </>
  ) : null;
};

export default VariationPriceList;
